import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import Question from "../../images/icons/question.svg";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

const useStyles = makeStyles((theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.1)`,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BAE5F9",
      outline: `1px solid #ffffff`,
      borderRadius: 10,
    },
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  fileContainer: {
    cursor: "pointer",
    height: 120,
    width: 500,
    pointerEvents: "auto",
    border: "2px dashed rgba(206,206,206,0.33)",
    borderRadius: 10,
    textAlign: "center",
    paddingTop: 10,
  },
}));

const PregnantFilesModal = ({
  handleClose,
  open,
  setShowMessage,
  message,
  setMessage,
  setDocuments,
  documents,
}) => {
  const classes = useStyles();
  setShowMessage(false);
  const [messageFiles, setMessageFiles] = useState("");
  const [errorFiles, setErrorFiles] = useState("");

  const adjuntarArchivos = (e) => {
    setDocuments([]);
    const docs = e.target.files;
    if (docs?.length > 5) {
      setMessageFiles(``);
      setErrorFiles(`Se pueden cargar máximo 5 archivos.`);
    } else if (docs?.length > 0 && docs?.length < 6) {
      setErrorFiles("");
      uploadDocuments(e.target.accept, e.target.files);
    }
  };

  const validateTypeSize = (accept, file) => {
    const fileSize = file.size / 1024 / 1024;
    if (file.type.toUpperCase() === "APPLICATION/PDF" && fileSize <= 5) {
      return true;
    }
    let formats = accept.toUpperCase().split(",");
    if (formats.includes(file.type.toUpperCase()) && fileSize <= 2) {
      return true;
    }
    return false;
  };

  const uploadDocuments = (accept, docs) => {
    for (let i = 0; i < docs.length; i++) {
      const isValid = validateTypeSize(accept, docs[i]);
      if (isValid) {
        setMessageFiles(`Se han agregado ${docs?.length} archivos`);
        const element = docs[i];
        convertToBase64(element);
        setErrorFiles("");
      } else {
        setDocuments([]);
        setMessageFiles(``);
        setErrorFiles(
          `El tamaño o tipo de los archivos adjuntos no es aceptado.`
        );
      }
    }
    setMessage({ ...message, open: false });
  };

  function convertToBase64(file) {
    let base64 = new FileReader();
    base64.readAsDataURL(file);
    base64.onload = function () {
      const newBase64 = base64.result.toString().replace(/^data:(.*,)?/, "");
      saveReports(newBase64, file);
      return base64.result;
    };
    base64.onerror = function (error) {

      return;
    };
  }

  const saveReports = async (result, file) => {
    var fileExtension = file.name.split(".").pop().toUpperCase();
    const newFile = {
      attachment: result,
      attachmentExtension: fileExtension,
      attachedName: file.name,
    };
    setDocuments((anterior) => [...anterior, newFile]);
  };

  return (
    <div>
      <Dialog
        PaperProps={{
          style: { borderRadius: 16, paddingLeft: 30, paddingRight: 30, paddingTop: 10,overflowY: "hidden", minHeight: "300px" },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ color: "#7EBDCE" }}>
          <div style={{ textAlign: "center" }}>
            <img src={Question} alt="" style={{ width: "10%" }} />
            <p style={{margin: "0"}}>¿Desea adjuntar algún archivo?</p>
          </div>
        </DialogTitle>
        <DialogContent style={{ minHeight: "180px", overflowY: "hidden" }}>
          <div>
            <input
              accept={[
                "application/pdf",
                "image/jpg",
                "image/png",
                "image/jpeg",
              ]}
              type="file"
              multiple
              onChange={(e) => adjuntarArchivos(e)}
              id="icon-button-file-exam"
              style={{ display: "none", pointerEvents: "auto" }}
            />
            <label htmlFor="icon-button-file-exam">
              <div className={classes.fileContainer}>
                <CloudUploadIcon color="disabled" style={{ fontSize: 50 }} />
                <p>Adjuntar archivos en formato PDF, JPG, PNG, JPEG</p>
              </div>
            </label>
          </div>
          {messageFiles && <p>{messageFiles}</p>}
          {errorFiles && <p style={{ color: "red" }}>{errorFiles}</p>}
          <p style={{margin: "0"}}>* Máximo 5 archivos</p>
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-around" }}>
          <Button
            onClick={() => handleClose(false)}
            color="primary"
            variant="outlined"
            style={{ color: "#7EBDCE", borderColor: "#E1E1E1" }}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => handleClose(true)}
            color="primary"
            autoFocus
            style={{ backgroundColor: "#7EBDCE", color: "#ffffff" }}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default PregnantFilesModal;
